import React from 'react'
import { withRouter } from 'react-router-dom'

import { Button } from 'primereact/button'

import { AuthContext } from '../main/authProvider'

import Card from '../components/card'
import * as popUp from '../components/toastr'
import HandleErrorService from '../app/service/handleErrorService'
import { InputTextarea } from 'primereact/inputtextarea'
import NFService from '../app/service/estoque/NFService'
import NfseService from '../app/service/nfse/NfseService'
import AuthService from '../app/service/authService'
import ConstantsUtil from '../context/constantsUtil'


class BuscarNFePorChave extends React.Component{

    constructor(){
        super();
        this.inputTextref = React.createRef()
        this.NFService = new NFService()
        this.NfseService = new NfseService()
    }

    isNFSe = () => window.location.pathname === ConstantsUtil.buscarNFSePorChavePathName

    getService = () => this.isNFSe() ? this.NfseService : this.NFService

    state = {


    }

    checkData = () => {
        if(!this.inputTextref.current.value){
            popUp.infoPopUp("Informe as chaves que deseja buscar.")
            return false
        }
        return true
    }

    buscarNotas = () => {
        if(this.checkData()){
            AuthService.startBlockUi()
            this.getService().buscarPorChaves({chaves: this.inputTextref.current.value})
            .then(response => {
                popUp.successPopUp("Notas Fiscais importadas com sucesso!")
            })
            .catch(error => {
                HandleErrorService.handleError(error)
            })
            .finally(() => {
                AuthService.stopBlockUi()
            })
        }
    }

    atualizarCadeiaCertificacaoSefaz = () => {
        AuthService.startBlockUi()
        this.NFService.geraCadeiaCertificacaoSefaz()
        .then(response => {
          popUp.successPopUp("Cadeia de certificação da SEFAZ atualizada com sucesso!")  
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            AuthService.stopBlockUi()
        })
    }

    render(){

        const dedent = (str) => str.replace(/^\s+/gm, '');


        const renderAtualizarCadeiaCertificacaoSefazButton = () => {
            if(AuthService.getPerfil().isAdmin)
            return (
                <Button 
                    label={"Atualizar cadeias de certificação da SEFAZ e do Portal Nacional das NFSe"}
                    icon="pi pi-refresh"
                    onClick = {this.atualizarCadeiaCertificacaoSefaz}
                />
            )
        }        

        return(
            <div className="bs-docs-section" >
            <Card
                title = {this.isNFSe() ? "Buscar NFSe por chave" : "Buscar NFe por chave"}
                rightComponent={renderAtualizarCadeiaCertificacaoSefazButton()}
            >
                
            <div className = "col-md-12">

                <div className="row">
                
                    <InputTextarea
                        ref={this.inputTextref}
                        rows={10} cols={1000}
                        autoResize
                        placeholder={dedent(`
                            Cole as chaves que deseja buscar, separadas por vírgula ou quebra de linha

                            Exemplos:

                            33251036242543000150550010000065261890970701
                            33251036242543000150550010000065261890970702
                            33251036242543000150550010000065261890970703

                            ou

                            33251036242543000150550010000065261890970701, 33251036242543000150550010000065261890970702, 33251036242543000150550010000065261890970703

                            Não se preocupe com formatação: quebras de linha, vírgulas, com ou sem espaços. O sistema saberá entender tudo corretamente.
                        `)}

                    />

                </div>

                <br />

                <div className="row">
                    <Button 
                        label="Buscar"
                        className='small-button'
                        icon="pi pi-search"
                        onClick = {this.buscarNotas}
                    />                
                </div>


            </div>

            </Card>
            <div className="d-flex "/>

            </div>
        )
    }

}

BuscarNFePorChave.contextType = AuthContext
export default withRouter( BuscarNFePorChave )